import { render, staticRenderFns } from "./AdwavDashboard.vue?vue&type=template&id=2c35a9b4&scoped=true&"
import script from "./AdwavDashboard.vue?vue&type=script&lang=js&"
export * from "./AdwavDashboard.vue?vue&type=script&lang=js&"
import style0 from "./AdwavDashboard.vue?vue&type=style&index=0&id=2c35a9b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c35a9b4",
  null
  
)

export default component.exports